import React from "react";
import { cn } from "../../lib/utils";

export const Button = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <button
      ref={ref}
      className={cn(
        "inline-flex items-center justify-center rounded-md bg-pink-600 px-4 py-2 text-white hover:bg-pink-700 text-sm font-medium transition",
        className
      )}
      {...props}
    />
  );
});

Button.displayName = "Button";
